export type TikTokProvider = {
  available: boolean;
  status?: string;
};

type ProviderResponse = {
  providers?: {
    tiktok?: TikTokProvider;
  };
};

export async function readTikTokProvider(): Promise<TikTokProvider> {
  try {
    const response = await fetch("/api/auth/providers", {
      credentials: "same-origin",
      headers: { accept: "application/json" },
    });
    if (!response.ok) return { available: false };
    const payload = await response.json() as ProviderResponse;
    const provider = payload.providers?.tiktok;
    return provider && provider.available === true
      ? provider
      : { available: false, status: provider?.status };
  } catch {
    return { available: false };
  }
}

export function beginTikTokLogin(): void {
  window.location.assign("/api/auth/tiktok/start");
}

const TIKTOK_NOTE_PATH = "M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.72-.02-.5-.03-1-.01-1.48.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.43-1.08 1.09-1.2 1.86-.1.55-.07 1.13.13 1.65.19.47.49.9.88 1.23.77.66 1.94.9 2.89.48.63-.26 1.14-.77 1.41-1.39.09-.22.14-.44.16-.68.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z";

export async function mountTikTokLogin(slot: HTMLElement | null): Promise<void> {
  if (!slot) return;
  const provider = await readTikTokProvider();
  if (!provider.available || document.getElementById("tiktok-entry")) return;

  const button = document.createElement("button");
  button.id = "tiktok-entry";
  button.type = "button";
  button.className = "account-submit account-submit--tiktok";
  button.dataset.authProvider = "tiktok";
  button.innerHTML = `
    <svg class="tiktok-note-mark" viewBox="-2 -2 28 28" aria-hidden="true" focusable="false">
      <path fill="#25F4EE" transform="translate(-0.7 0.55)" d="${TIKTOK_NOTE_PATH}" />
      <path fill="#FE2C55" transform="translate(0.7 -0.55)" d="${TIKTOK_NOTE_PATH}" />
      <path fill="#fff" d="${TIKTOK_NOTE_PATH}" />
    </svg>
    <span>Continue with TikTok</span>
  `;
  button.addEventListener("click", beginTikTokLogin);
  slot.append(button);
  slot.hidden = false;
}
